import React from 'react'
import { makeStyles, darken } from '@material-ui/core/styles'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import Button from '@material-ui/core/Button'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import ListItem from '@material-ui/core/ListItem'
import MenuIcon from '@material-ui/icons/Menu'
import Logo from '../../img/logo.svg'
import ManamIcon from '../../img/manam-icon.svg'
import ManamText from '../../img/manam-text.svg'
import { Link, withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { Fab } from '@material-ui/core'

const useStyles = makeStyles({
    fab: {
        background: 'linear-gradient(45deg, #e29d5c 30%, #e2b753 90%)',
        '&:hover, &:focus': {
            background: darken('#d7bb77', .15),
        }
    },
    list: {
        width: '50vw',
        background: '#024f45'
    }
})


const MobileMenu = ({ location }) => {
    const styles = useStyles()
    const [state, setState] = React.useState({
        left: false,
    })

    const toggleDrawer = (side, open) => event => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [side]: open })
    }

    const authInfo = useSelector(state => state.authInfo)

    const handleLogout = () => {
        localStorage.clear()
        window.location.reload()
    }

    const sideList = side => (
        <div
            className={styles.list}
            role="presentation"
            onClick={toggleDrawer(side, false)}
            onKeyDown={toggleDrawer(side, false)}
        >
            <List id='mobile-menu-list'>
                <ListItem>
                    <img src={ManamIcon} alt="" />
                </ListItem>
                <ListItem>
                    <img src={ManamText} alt="" />
                </ListItem>
            </List>

            <Divider className='mt-3 mb-3' />

            {!isEmpty(authInfo)
                ? <ListItem>
                    <Link to='/dashboard'>
                        <Fab
                            variant='extended'
                            className={styles.fab}
                        >
                            <section className='dashboard-icon'>
                                <i class="fas fa-user-circle"></i>
                                <span>{authInfo.fullname}</span>
                            </section>
                        </Fab>
                    </Link>
                </ListItem>
                : null
            }

            <List className='p-2'>
                <ListItem>
                    <Link to='/' className='text-white'>خانه</Link>
                </ListItem>

                <ListItem>
                    <Link to='/programmers' className='text-white'>برنامه نویس ها</Link>
                </ListItem>

                <ListItem>
                    <Link to='/people' className='text-white'>کاربران عادی</Link>
                </ListItem>

                {isEmpty(authInfo)
                    ? <ListItem>
                        <Link to='/login' className='text-white'>ورود</Link>
                    </ListItem>
                    : null
                }

                {isEmpty(authInfo)
                    ? <ListItem>
                        <Link to='/register' className='text-white'>ثبت نام</Link>
                    </ListItem>
                    : null
                }
            </List>

            <Divider className='mt-3 mb-3' />

            {!isEmpty(authInfo)
                ? <ListItem>
                    <Button
                        variant='contained'
                        onClick={handleLogout}
                        color='secondary'
                    ><strong>خروج</strong></Button>
                </ListItem>
                : null
            }

            <section style={{ height: '50vh' }}></section>
        </div>
    )

    return (
        <header id='mobile-menu'>
            <Button onClick={toggleDrawer('left', true)}>
                <MenuIcon style={{ color: 'white' }} />
            </Button>

            <img src={Logo} alt="" />

            <SwipeableDrawer
                open={state.left}
                onClose={toggleDrawer('left', false)}
                onOpen={toggleDrawer('left', true)}
            >
                {sideList('left')}
            </SwipeableDrawer>
        </header>
    )
}

export default withRouter(MobileMenu)